import React, { Component } from 'react';
import MacrosEffect from 'effects/live/MacrosEffect.js';
import Effects from 'effects/Effects.js';
import EffectsChainChooser from './EffectsChainChooser.js';
import Dropdown from 'react-dropdown';
import AutoWahEffect from 'effects/AutoWah.js';
import UltraPhaser from 'effects/UltraPhaser.js';
import ConditionedComponent from 'components/ConditionedComponent.js';
import ConvolverReverbEffect from 'effects/ConvolverReverbEffect.js';
import MultibandCompressor from 'effects/MultibandCompressor.js';
import DelayEffect from 'effects/Delay.js';
import StereoWidener from 'effects/StereoWidener.js';
import EQ8 from 'effects/EQ8.js';
import WarpEffect from 'effects/midi/WarpEffect.js';
import PhaserEffect from 'effects/Phaser.js';
import CompressorEffect from 'effects/Compressor.js';
import DistortionEffect from 'effects/Distortion.js';
import BitCrusherEffect from 'effects/BitCrusher.js';
import EQ3Effect from 'effects/EQ3.js';
import AlternateTuningEffect from 'effects/midi/AlternateTuningEffect.js';
import EQ10Effect from 'effects/EQ10.js';
import GateEffect from 'effects/Gate.js';
import PitchShift from 'effects/PitchShift.js';
import Panner from 'effects/Panner.js';
import Chebyshev from 'effects/Chebyshev.js';

import ArpEffect from 'effects/midi/ArpEffect.js';
import HarmonyEffect from 'effects/midi/HarmonyEffect.js';
import EveryEffect from 'effects/midi/EveryEffect.js';
import ParameterEffect from 'effects/midi/ParameterEffect.js';
import TimingEffect from 'effects/midi/TimingEffect.js';
import MidiDelayEffect from 'effects/midi/MidiDelayEffect.js';
import ChordRhythmEffect from 'effects/midi/ChordRhythmEffect.js';
import ChordSculptorEffect from 'effects/midi/ChordSculptorEffect.js';
import MidiInterfaceEffect from 'effects/midi/MidiInterfaceEffect.js';
import RollEffect from 'effects/live/RollEffect.js';
import PaletteEffect from 'effects/live/PaletteEffect.js';
import PlayheadEffect from 'effects/live/PlayheadEffect.js';
import MidiEffectRack from 'effects/midi/MidiEffectRack.js';
import MidiOutputter from 'effects/midi/MidiOutputter.js';
import TidalEffect from 'effects/midi/TidalEffect.js';
import {PLAYHEAD_EFFECT, ROLL_EFFECT, MACROS_EFFECT, PALETTE_EFFECT} from 'effects/live/constants.js';
import {setContextualHelp} from "actions/index.js";
import {setEffectsChainToShow} from "actions/index.js";
import {
    midiEffectOptions,
    getMidiEffectOptions,
    initializeMidiEffect,
    effectOptions,
    getEffectOption,
    initializeEffect} from './constants.js';
import {ADD_EFFECTS_BUTTON} from 'constants/contextual-help.js';
import { connect } from "react-redux";

function getLiveEffectOptions(value) {
    var options = liveEffectOptions.filter((opt) => opt.value === value);
    return options[0];
}

const liveEffectOptions = [
    {value: MACROS_EFFECT, label:'Macro'},
    {value: PLAYHEAD_EFFECT, label:'Playhead'},
    {value: PALETTE_EFFECT, label:'Palette'},
    {value: ROLL_EFFECT, label:'Roll'}
];

class AddEffect extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showOptions: true,
        };
    }

    handleChooseLiveEffect(name) {
        var effect = null;

        if (name === ROLL_EFFECT) {
            effect = new RollEffect(this.props.track);
        } else if (name === MACROS_EFFECT) {
            effect = new MacrosEffect(this.props.track);
        } else if (name === PALETTE_EFFECT) {
            effect = new PaletteEffect(this.props.track);
        } else if (name === PLAYHEAD_EFFECT) {
            effect = new PlayheadEffect(this.props.track);
        }

        this.props.handleChooseLiveEffect(effect);
        this.setState(this.state);
    }

    handleChooseMidiEffect(name) {
        this.props.handleChooseMidiEffect(initializeMidiEffect(name, this.props.track));
        this.setState(this.state);
    }

    handleChooseEffect(name) {
        var send = this.props.send;
        var effect = initializeEffect(name, this.props.sequencerEngine)
        this.props.handleChooseEffect(effect);
        this.setState(this.state);
    }

    onClickShowOptions() {
        this.state.showOptions = true;
        this.setState(this.state);
    }

    setContextualHelp(e, contextualHelp) {
        e.stopPropagation();
        this.props.setContextualHelp(contextualHelp);
    }

    render() {
        if (!this.state.showOptions) {
            let effectsChains = this.props.track === undefined ?
                [] :
                this.props.track.effectsChains;
            return (
                <div className="effects-chooser-container">
                  <div
                    onMouseOver={(e) => this.setContextualHelp(e, ADD_EFFECTS_BUTTON)}
                    onMouseLeave={() => this.props.setContextualHelp(undefined)}
                    onClick={() => this.onClickShowOptions()} className={this.props.addClassName}>+</div>
                  <ConditionedComponent condition={!window.installation}>
                    <EffectsChainChooser track={this.props.track}/>
                  </ConditionedComponent>
                </div>
            );
        } else {
            return (
                <div className="enabled effect choose-effects">
                  <div className="add-effect-type">
                    <Dropdown
                      className='delay-time-dropdown'
                      options={effectOptions}
                      onChange={(o) => this.handleChooseEffect(o.value)}
                      placeholder="Audio FX" />
                  </div>
                  <ConditionedComponent condition={this.props.track !== undefined}>
                    <div className="add-effect-type">
                      <Dropdown
                        className='delay-time-dropdown'
                        options={midiEffectOptions}
                        onChange={(o) => this.handleChooseMidiEffect(o.value)}
                        placeholder="MIDI FX" />
                    </div>
                    <ConditionedComponent condition={!window.installation}>
                      <div className="add-effect-type">
                        <Dropdown
                          className='delay-time-dropdown'
                          options={liveEffectOptions}
                          onChange={(o) => this.handleChooseLiveEffect(o.value)}
                          placeholder="Live FX" />
                      </div>
                    </ConditionedComponent>
                  </ConditionedComponent>
                </div>
            );
        }
    }
}

const mapStateToProps = (state, props) => {
    let chainNumber = 0;
    if (props.track) {
        chainNumber = props.track.chainNumber;
    }
    return {
        chainNumber: chainNumber,
    };
};

const mapDispatchToProps = (dispatch, props) => {
    return {
        setContextualHelp: (element) => dispatch(setContextualHelp(element)),
        setEffectsChainToShow:  (subSequenceId, trackNumber, fxChain) => dispatch(setEffectsChainToShow(
            subSequenceId, trackNumber, fxChain)),
    };
}
 
export default connect(mapStateToProps, mapDispatchToProps)(AddEffect);
